import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { ImportExportItemsEnum } from 'Common/FieldEnum';
import { IMPORT_ITEMS_FORM_NAME } from 'Common/FormEnum';
import { DATE_FORMAT_FOR_UI, FILE_DELIMITER_MAP } from 'Common/Constants';
import { ImportExportTypeOptionsEnum } from 'Common/Constants/Enumeration/ImportExportInventoryEnum';
import { toastError } from 'Common/ToastHelper';
import { resetForm } from 'State/forms/actions';
import {
  postImportItemsFile,
  addColumnMapping,
  clearImportItemsData,
} from './../../../state/importExport/actions';
import {
  validateColumnData,
  getColumnOptions,
} from './../../../helper/importExport';
import ImportItemsComponent from './../components/ImportItems';
import * as Selectors from '../../../state/importExport/selector';

class ImportItems extends Component {
  static propTypes = {
    importType: PropTypes.number,
    delimiter: PropTypes.string,
    importBidPrice: PropTypes.bool,
    importItems: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
    loadPreviousImportOptionsDropDown: PropTypes.array.isRequired,
    existingImportConfig: PropTypes.array.isRequired,
  };
  static defaultProps = {
    importType: ImportExportTypeOptionsEnum.OneTimeOnly,
    delimiter: FILE_DELIMITER_MAP.COMMA.value,
    importBidPrice: false,
  };
  currentDate = moment();
  state = {
    fromDateMax: null,
    toDateMin: null,
  };

  onChangeOfFromDT = (e, beginDate, prevDate) => {
    beginDate !== prevDate && this.selectFromDate(e, beginDate);
  };

  onChangeOfToDT = (e, endDate, prevDate) => {
    endDate !== prevDate && this.selectToDate(e, endDate);
  };

  selectFromDate = (e, beginDate) => {
    this.props.setIsDirty(true);
    this.setState({
      toDateMin: moment(beginDate, DATE_FORMAT_FOR_UI),
    });
  };

  selectToDate = (e, endDate) => {
    this.props.setIsDirty(true);
    this.setState({
      fromDateMax: moment(endDate, DATE_FORMAT_FOR_UI),
    });
  };
  handleFilePreview = file => {
    const { postImportItemsFile, delimiter, setFile } = this.props;
    const formData = new FormData();
    setFile(file);
    formData.append('delimiter', delimiter);
    formData.append('import_file', file);
    postImportItemsFile(formData);
  };
  uploadAnotherFile = () => {
    const { studentHeader = { Data: [] }, addColumnMapping } = this.props;

    if (studentHeader.Data.length) {
      addColumnMapping(studentHeader.Data);
    }
  };
  clearMappingHandler = () => {
    this.props.addColumnMapping([]);
    this.props.clearImportItemsData();
    this.handleFilePreview(this.props.file);
  };
  uploadAnotherFileBtnClick = () => {
    this.props.clearImportItemsData();
    this.uploadAnotherFile();
  };
  updatePreviewData = (value, i) => {
    const { columnMapping, addColumnMapping, columns, setIsDirty } = this.props;
    const [success, columnMappingData, column] = validateColumnData(
      value,
      i,
      columnMapping,
      columns,
      1
    );

    if (!success) {
      toastError(`You have already selected the field ${column.text}`);
    }

    addColumnMapping(columnMappingData);
    setIsDirty(true);
    return success;
  };
  onChangeConfig = (e, selectedId) => {
    const { existingImportConfig, change, setIsDirty } = this.props;
    const selectedObject = _.find(existingImportConfig, item => {
      return item.Id === selectedId;
    });
    setIsDirty(false);
    if (selectedObject) {
      change(
        [ImportExportItemsEnum.IncludeHeaders],
        selectedObject[ImportExportItemsEnum.IncludeHeaders]
      );
      change(
        [ImportExportItemsEnum.Delimiter],
        selectedObject[ImportExportItemsEnum.Delimiter]
      );
      change(
        [ImportExportItemsEnum.ImportBidPrice],
        selectedObject[ImportExportItemsEnum.ImportBidPrice]
      );
      selectedObject[ImportExportItemsEnum.ImportBidPrice] &&
        selectedObject[ImportExportItemsEnum.BeginDT] &&
        change(
          [ImportExportItemsEnum.BeginDT],
          selectedObject[ImportExportItemsEnum.BeginDT]
        );
      selectedObject[ImportExportItemsEnum.ImportBidPrice] &&
        selectedObject[ImportExportItemsEnum.EndDT] &&
        change(
          [ImportExportItemsEnum.EndDT],
          selectedObject[ImportExportItemsEnum.EndDT]
        );
      try {
        selectedObject[ImportExportItemsEnum.SelectedFields] &&
          this.props.addColumnMapping(
            JSON.parse(selectedObject[ImportExportItemsEnum.SelectedFields])
          );
      } catch (e) {
        toastError('Error in selected column mapping');
      }
    }
  };
  onChangeImportType = value => {
    const { resetForm, change, addColumnMapping, setIsDirty } = this.props;
    resetForm(IMPORT_ITEMS_FORM_NAME);
    change([ImportExportItemsEnum.Type], value);
    addColumnMapping([]);
    setIsDirty(false);
  };
  onChangeOfBidPrice = () => {
    this.props.setIsDirty(true);
  };
  render() {
    const {
      importType,
      importItems,
      columnMapping,
      notificationSystem,
      importBidPrice,
      handleSubmit,
      loadPreviousImportOptionsDropDown,
    } = this.props;
    const {
      Data: importItemsData = [],
      Errors: importItemsErrors = [],
    } = importItems;
    const { fromDateMax, toDateMin } = this.state;
    return (
      <ImportItemsComponent
        handleSubmit={handleSubmit}
        loadPreviousImportOptionsDropDown={loadPreviousImportOptionsDropDown}
        onChangeImportType={this.onChangeImportType}
        onChangeConfig={this.onChangeConfig}
        importType={importType}
        importBidPrice={importBidPrice}
        onChangeOfFromDT={this.onChangeOfFromDT}
        onChangeOfToDT={this.onChangeOfToDT}
        toDateMin={toDateMin}
        importItemsErrors={importItemsErrors}
        importItemsData={importItemsData}
        columnMapping={columnMapping}
        notificationSystem={notificationSystem}
        fromDateMax={fromDateMax}
        handleFilePreview={this.handleFilePreview}
        columns={this.props.columns}
        updatePreviewData={this.updatePreviewData}
        uploadAnotherFile={this.uploadAnotherFile}
        clearMappingHandler={this.clearMappingHandler}
        uploadAnotherFileBtnClick={this.uploadAnotherFileBtnClick}
        onChangeOfBidPrice={this.onChangeOfBidPrice}
      />
    );
  }
}

ImportItems = reduxForm({
  destroyOnUnmount: false,
  form: IMPORT_ITEMS_FORM_NAME,
})(ImportItems);

const mapStateToProps = state => {
  const { importExport } = state.UtilitiesState;
  const { columns } = importExport;
  const selector = formValueSelector(IMPORT_ITEMS_FORM_NAME);
  const importBidPrice = selector(state, ImportExportItemsEnum.ImportBidPrice);
  return {
    importType: selector(state, ImportExportItemsEnum.Type),
    delimiter: selector(state, ImportExportItemsEnum.Delimiter),
    importBidPrice,
    importItems: Selectors.getImportItems(state),
    columns: getColumnOptions(columns, importBidPrice),
    loadPreviousImportOptionsDropDown: Selectors.getLoadPreviousImportOptionsDropDown(
      state
    ),
    existingImportConfig: Selectors.getExistingImportConfig(state),
  };
};
const mapDispatchToProps = {
  postImportItemsFile,
  addColumnMapping,
  clearImportItemsData,
  resetForm,
};
export const ImportItemsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportItems);



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/importInventory/containers/ImportItems.js